module.exports = __webpack_public_path__ + "img/icon-35.28c65a55.svg";